import Env from '../base/env';
import { module as BaseModule } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { animationText,animationReveal } from '../fx/Common'

export default class extends BaseModule  {
  constructor(m) {
    super(m);
  }

  init()
  {
    this.DOM = {}
    this.DOM.view = this.el
    this.DOM.sticky = this.DOM.view.querySelector('.fxSticky')
    this.DOM.text = this.DOM.view.querySelector('.fxText')
    //!
    this.fx()
  }

  fx()
  {
    animationText({trigger:this.DOM.view,text:this.DOM.text})
    animationReveal({trigger:this.DOM.view,DomToReveal:this.DOM.view})
    this.stickyText()
  }

  stickyText()
  {
    this.stText = ScrollTrigger.create({
      trigger: this.DOM.view,
      start:'top top',
      end:'bottom top',
      // pin:this.DOM.sticky,
      markers:false,
      onLeave:()=> Env.$html.classList.add('ui-black'),
      onEnterBack:()=> Env.$html.classList.remove('ui-black')
    })
  }

  destroy()
  {

  }
}
